import React, { useState, useEffect } from "react";
import { BottomScrollListener, useBottomScrollListener } from "react-bottom-scroll-listener";
import $ from "jquery";
import CartContent from "./CartContent";
import ErrorModal from "./ErrorModal";
import FullScreenLoadingOverlay from "./FullScreenLoadingOverlay";
import ShowLargeImageModal from "./ShowLargeImageModal";
import I18n from 'i18n.js.erb'
import AlertPopup from "./AlertPopup";
import {
  CURRENCY_EURO, DEFAULT_PER_PAGE_PARAM,
  DESKTOP_WIDTH,
  IPAD_WIDTH,
  isValidUserAddress, parseAmount,
  parseBigInteger, pluralize,
  scrollManagerInTabPages
} from "../../utils/utils";
import IconTooltip from "./IconTooltip";
import PaymentAndShippingForm from "./PaymentAndShippingForm";
import {removeCartItemsQuantity} from "../../reducers/cart_icon_reducer";
import {useDispatch} from "react-redux";
import SuccessFlashMessage from "./SuccessFlashMessage";

const Cart = ({
  cart,
  sorting_options,
  sorting_directions,
  shipment_addresses,
  countries,
  isBusinessAccount
}) => {
  
  const originalCart = JSON.parse(cart);
  const dispatch = useDispatch();
  const [ initCompleted, setInitCompleted ] = useState(false)
  const [ cartItems, setCartItems ] = useState([]);
  const [ amount, setAmount ] = useState(originalCart.amount)
  const [ numberOfProducts, setNumberOfProducts ] = useState(originalCart.number_of_products)
  const [ notAvailableForSaleProducts, setNotAvailableForSaleProducts ] = useState(originalCart.not_available_for_sale_cart_items)
  const initialFilters = { not_available_for_sale_cards: null, sort_by: 'id', sorting_direction: 'asc' }
  const [ filters, setFilters ] = useState(initialFilters)
  const [ page, setPage ] = useState(1);
  const [ hasLoadedAllCartItems, setHasLoadedAllCartItems ] = useState(false);
  const [ loading, setLoading ] = useState(false);
  const [ proceedToOrder, setProceedToOrder ] = useState(false);
  const [ orderConfirmed, setOrderConfirmed ] = useState(false);
  const [ validShipmentAddress, setValidShipmentAddress ] = useState(true);
  const [ showSuccessFlashMessage, setShowSuccessFlashMessage ] = useState(false)
  const [ showErrorModal, setShowErrorModal ] = useState(false)
  const [ showZoomImg, setShowZoomImg ] = useState(false)
  const [ blueprintImage2ShowLargeImage, setBlueprintImage2ShowLargeImage ] = useState(null)
  const [ isOrderInProgress, setIsOrderInProgress ] = useState(false);
  const [ actionsPannelIsOpen, setActionsPannelIsOpen ] = useState($(window).innerWidth() >= DESKTOP_WIDTH);
  const [ showDeleteAllItemsPopup, setShowDeleteAllItemsPopup ] = useState(false)
  const [ itemToDelete, setItemToDelete ] = useState(false)
  const [ itemToDeletePrice, setItemToDeletePrice ] = useState(false)
  const [ itemToDeleteAvailableForSale, setItemToDeleteAvailableForSale ] = useState(false)
  const [ showDeleteItemPopup, setShowDeleteItemPopup ] = useState(false)
  

  //Funzione jquery che mi permette di gestire la variazione dello z-index del menù azioni quando scrollo
  $(window).on("scroll", function () {
    scrollManagerInTabPages('#actions')
  });

  useEffect(() => {
    if (proceedToOrder) {
      $('#nav-tab a[href="#nav-tab2"]').tab('show')
    }
  }, [proceedToOrder]);

  useEffect(() => {
    if (proceedToOrder && orderConfirmed) {
      $('#nav-tab a[href="#nav-tab3"]').tab('show')
    }
  }, [orderConfirmed]);

  useEffect(() => {
    if (initCompleted && cartItems.length === 0) {
      getCartItems()
    }
  }, [cartItems]);


  useEffect(() => {
    if (!initCompleted) {
      setInitCompleted(true)
      appendCartItems(originalCart.cart_items)
    }
  }, []);


  // Hook che permette il caricamento di nuovi prodotti del carrello da renderizzare sull'interfaccia
  // grafica non appena l'utente scrolla fino in fondo alla pagina (INFINITE SCROLL)
  const scrollRef = useBottomScrollListener(() => getCartItems());


  // Funzione che permette di ottenere dal server nuovi prodotti del carrello da renderizzare sull'interfaccia grafica
  const getCartItems = () => {
    if (!hasLoadedAllCartItems) {
      let url = `/carts/${originalCart.id}/edit.json?page=${page}&per_page=${DEFAULT_PER_PAGE_PARAM}`
      Object.entries(filters).forEach(([fieldName, fieldValue]) => {
        if (fieldValue !== null)
          url += `&${fieldName}=${fieldValue}`
      })

      fetch(url, {
        method: 'GET'
      })
        .then(response => response.json())
        .then((data) => {
          setLoading(false)
          appendCartItems(data.cart_items)
          setNotAvailableForSaleProducts(data.not_available_for_sale_cart_items)
        })
        .catch((error) => {
          console.error("ERROR:", error);
          setShowErrorModal(true);
        });
    }
  }


  // Funzione che permette di concatenare i nuovi prodotti ottenuti del server all'array che contiene tutti 
  // i prodotti del carrello da mostrare sull'interfaccia grafica all'utente
  const appendCartItems = (newCartItems) => {
    setCartItems(cartItems.concat(newCartItems));
    setPage(page + 1)
    if (newCartItems.length < DEFAULT_PER_PAGE_PARAM)
      setHasLoadedAllCartItems(true)
  }


  // Funzione che permette di ottenere dal server i prodotti del carrello dell'utente che matchano con i filtri
  // di ricerca da lui specificati sull'interfaccia grafica
  const getCartItemsByMatchingFilters = (filter, value) => {
    const newFilters = { ...filters }
    newFilters[filter] = value;
    updateFilters(newFilters)
    if (window.innerWidth < IPAD_WIDTH)
      setActionsPannelIsOpen(false)
  }


  // Funzione che aggiorna i filtri di ricerca dei prodotti specificati dall'utente sull'interfaccia grafica
  const updateFilters = (newFilters) => {
    setFilters(newFilters)
    setLoading(true)
    setPage(1)
    setHasLoadedAllCartItems(false)
    setCartItems([]);
  }


  //Funzione che elimina un prodotto specifico dal carrello dell'utente
  function onDeleteHandler(cartItemId, price, available_for_sale) {
    const url = `/cart_items/${cartItemId}`;

    fetch(url, {
      method: "DELETE",
    })
      .then((response) => {
        console.log("response: ", response);
      })
      .then((data) => {
        let newCartItems = cartItems.filter((cartItem) => cartItem.id !== cartItemId);
        setCartItems(newCartItems);
        if (available_for_sale) {
          setAmount(amount - price)
          setNumberOfProducts(numberOfProducts - 1)
        }
        dispatch(removeCartItemsQuantity(1));
        setShowSuccessFlashMessage(true)
      })
      .catch((error) => {
        console.error("ERROR:", error);
        setShowErrorModal(true);
      });
  }


  //Funzione che elimina TUTTI i prodotti presenti all'interno del carrello dell'utente
  function onDeleteAllHandler() {
    if (numberOfProducts) {
      const url = `/carts/delete_all_items/${originalCart.id}`;

      const cartItemsIds = cartItems.map((cartItem) => {
        return cartItem.id
      });

      fetch(url, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({cart_items_ids: cartItemsIds}),
      })
        .then((response) => {
          console.log("response: ", response);
        })
        .then((data) => {
          setCartItems([]);
          setAmount(0)
          dispatch(removeCartItemsQuantity(numberOfProducts));
          setNumberOfProducts(0)
          setNotAvailableForSaleProducts(0)
          setActionsPannelIsOpen(false)
          setShowSuccessFlashMessage(true)
        })
        .catch((error) => {
          console.error("ERROR:", error);
          setShowErrorModal(true);
        });
    }
  }


  // Funzione che conferma il contenuto del carrello dell'utente e gli permette di procedere
  function proceedToOrderHandler() {
    if (numberOfProducts > 0) {
      setProceedToOrder(true);
      $('#nav-tab a[href="#nav-tab2"]').tab('show')
    }
  }


  // Funzione che valida i dati di spedizione e di pagamento scelti dall'utente prima di evadere l'ordine
  function confirmOrderHandler(shipmentAddresses, isANewAddress, oldAddressId, isDefaultSettings) {
    if (numberOfProducts > 0) {
      if (isANewAddress) {
        if (isValidUserAddress(shipmentAddresses)) {
          let url = "/orders?";
          Object.entries(shipmentAddresses).forEach(([fieldName, fieldValue]) => {
            if (fieldValue !== null)
              url += `&${fieldName}=${fieldValue}`
          })

          setIsOrderInProgress(true)
          fetch(url, {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ cart_id: originalCart.id, is_default: isDefaultSettings ? 'default' : 'not_default' }),
          })
            .then((res) => {
              setIsOrderInProgress(false)
              if (!res.ok)
                throw Error("An error occour during saving data on the database");
              else
                return res.json()
            })
            .then((data) => {
              setValidShipmentAddress(true)
              setOrderConfirmed(true)
              setCartItems([])
              setAmount(0)
              dispatch(removeCartItemsQuantity(numberOfProducts));
              setNumberOfProducts(0)
              $('#nav-tab a[href="#nav-tab3"]').tab('show')
            })
            .catch((error) => {
              console.error("ERROR:", error);
              setShowErrorModal(true);
            });

        } else {
          setValidShipmentAddress(false)
        }
      } else {
        let url = "/orders";

        fetch(url, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ shipment_address_id: oldAddressId, cart_id: originalCart.id, is_default: isDefaultSettings ? 'default' : 'not_default' }),
        })
          .then((res) => {
            if (!res.ok)
              throw Error("An error occour during saving data on the database");
            else
              return res.json()
          })
          .then((data) => {
            setValidShipmentAddress(true)
            setOrderConfirmed(true)
            setCartItems([])
            setAmount(0)
            dispatch(removeCartItemsQuantity(numberOfProducts));
            setNumberOfProducts(0)
            $('#nav-tab a[href="#nav-tab3"]').tab('show')
          })
          .catch((error) => {
            console.error("ERROR:", error);
            setShowErrorModal(true);
          });
      }
    }
  }


  // Funzione che permette di mostrare in full-screen l'immagine ingrandita di una carta
  const handleShowLargeImage = (e, blueprintImage) => {
    e.stopPropagation()
    if (blueprintImage) {
      setBlueprintImage2ShowLargeImage(blueprintImage)
      setShowZoomImg(true)
    }
  }


  //Funzione che gestisce l'apertura del popup per eliminare un articolo
  function showPopupToDeleteItem(id, price, availableForSale) {
    setItemToDelete(id)
    setItemToDeletePrice(price)
    setItemToDeleteAvailableForSale(availableForSale)
    setShowDeleteItemPopup(true)
  }

  
  return (
    <React.Fragment>
      {/*menù azioni*/}

      {
        !actionsPannelIsOpen ?
          <React.Fragment>
            {/*mobile button*/}
            {
              cartItems.length > 0 &&
              <div className="button-show-all-sub-expansion-on-mobile show-on-mobile-d-block ">
                <button type="button" className="btn"
                        onClick={() => setActionsPannelIsOpen(true)}>
                  <i className="fas fa-pencil-alt icon-in-btn-size ml-8px text--size-27px-imp"/>
                </button>
              </div>
            }

          </React.Fragment>
          :
          <React.Fragment>
            <div
              className={`pl-4 pr-4 pb-4  actions-menu-fixed-on-top bg-light overflow-auto shadow`}
              id="actions">
              <div className="row">
                <div className="col-12 text-right p-lg-0">
                  <button type="button" className="btn p-0 mt-8px mr-4px"
                          onClick={() => setActionsPannelIsOpen(false)}>
                    <i className="fas fa-times show-on-mobile"/>
                  </button>
                </div>
              </div>

              <div className="row mt-10px">
                <div className="col-lg-3 col-md-6 col-12 mb-2 mb-20px-imp">
                  <p className="mb-0">{I18n.t('js.indexOrdersPage.sortBy')}</p>
                  <div className="d-flex justify-content-start align-items-center">
                    <select className={`form-control ${filters.sort_by ? 'border-aiG-blue-imp' : ''} mr-1 p-0`}
                            name="sort_by" id="sort_by" value={filters.sort_by}
                            style={{ minWidth: "60%" }}
                            onChange={(e) => getCartItemsByMatchingFilters("sort_by", e.target.value) } >
                      {sorting_options.map(option => {
                        return <option value={option.value} key={option.value}>{I18n.t(option.locale)}</option>
                      })}
                    </select>
                    <span>
                        <b>:</b>
                      </span>
                    <select className={`form-control ${filters.sorting_direction ? 'border-aiG-blue-imp' : ''} ml-1 p-0`}
                            name="sorting_direction" id="sorting_direction" value={filters.sorting_direction}
                            onChange={(e) => getCartItemsByMatchingFilters('sorting_direction', e.target.value)} >
                      {sorting_directions.map(direction => {
                        return <option value={direction.value} key={direction.value}>{I18n.t(direction.locale)}</option>
                      })}
                    </select>
                  </div>
                </div>

                <div className="col-lg-2 col-md-6 col-12 mb-2 mb-20px-imp">
                  <button
                    type="button"
                    className="btn-standard-outline pr-2 pl-2 btn-standard-outline-resized h-100 pt-10px-imp w-100"
                    onClick={() =>
                      setShowDeleteAllItemsPopup(true)
                    }
                  >
                    {I18n.t('js.editSubmissionListPage.actionsMenuDeleteCard')}
                  </button>
                </div>

                <div className="col-lg-2 col-md-6 col-12 mb-2 mb-20px-imp show-on-desktop">
                  <div className="d-flex align-items-center h-100">
                    <h3 className="mb-0 text-weight-700 mt-0">
                      {parseBigInteger(numberOfProducts)}&nbsp;
                      {pluralize(numberOfProducts, 'editSubmissionListPage.product')}
                    </h3>
                  </div>
                </div>

                <div className="col-lg-2 col-md-6 col-12 mb-2 mb-20px-imp show-on-desktop">
                  <div className="d-flex align-items-center h-100">
                    <h3 className="mb-0 text-weight-700 mt-0">
                      {I18n.t('js.editSubmissionListPage.price')}&nbsp;
                      {parseAmount(amount) + CURRENCY_EURO}
                    </h3>
                  </div>
                </div>

                {
                  notAvailableForSaleProducts > 0 &&
                    <div className="col-lg-3 col-md-6 col-12 mb-2 mb-20px-imp">
                      <div className="d-flex align-items-center h-100 cursor-pointer color-red"
                              onClick={ (e) => getCartItemsByMatchingFilters('not_available_for_sale_cards', true) }>
                        <div>
                          <IconTooltip
                            tooltipPosition={'top'}
                            tooltipIcon={'fas fa-exclamation-triangle'}
                            tooltipTitle={''}
                            tooltipContent={I18n.t('js.editCartPage.warningTooltipContent')}
                            iconColor={'red'}
                          />
                        </div>
                        <div className="ml-2">
                          {I18n.t('js.editCartPage.yourCartContains')}&nbsp;
                          {notAvailableForSaleProducts}&nbsp;
                          {pluralize(notAvailableForSaleProducts, 'editSubmissionListPage.product')}&nbsp;
                          {pluralize(notAvailableForSaleProducts, 'editCartPage.notAvailableForSaleProduct')}
                        </div>
                      </div>
                    </div>
                }

              </div>

            </div>
          </React.Fragment>
      }



      <div className={`${actionsPannelIsOpen && 'mt-190px-imp'}`}>
        <h2 className='text-center text-lg-left p-3 mb-2 mt-3'>{I18n.t('js.editCartPage.myCart')}</h2>

        <div className="row show-on-mobile pl-20px pr-20px">
          <div className="col-lg-2 col-md-4 col-6 mb-2 mb-20px-imp pr-0">
            <div className="d-flex align-items-center h-100">
              <h3 className="mb-0 mt-20px">
                {parseBigInteger(numberOfProducts)}&nbsp;
                {pluralize(numberOfProducts, 'editSubmissionListPage.product')}
              </h3>
            </div>
          </div>

          <div className="col-lg-2 col-md-4 col-6 mb-2 mb-20px-imp pl-0">
            <div className="d-flex align-items-center h-100">
              <h3 className="mb-0 mt-20px">
                {I18n.t('js.editSubmissionListPage.price')}&nbsp;
                {parseAmount(amount) + CURRENCY_EURO}
              </h3>
            </div>
          </div>


        </div>

        <nav>
          <div className="nav nav-tabs nav-fill justify-content-center show-on-desktop border-blu-aiGrading" id="nav-tab" role="tablist">
            <a className="nav-item nav-link aiGrading-tab active" id="nav-tab1-tab" data-toggle="tab"
               href={"#nav-tab1"}
               role="tab" aria-controls="nav-tab1" aria-selected="true">
              <i className="fas fa-shopping-cart" /><b className="ml-2">{I18n.t('js.editCartPage.tabCartContent').toUpperCase()}</b>
            </a>
            <a className={`nav-item nav-link aiGrading-tab ${!proceedToOrder ? 'disabled' : ''}`} id="nav-tab2-tab" data-toggle="tab"
               href={"#nav-tab2"}
               role="tab" aria-controls="nav-tab2" aria-selected="false">
              <i className="fas fa-shipping-fast" /><b className="ml-2">{I18n.t('js.editCartPage.tabPaymentShipping').toUpperCase()}</b>
            </a>
            <a className={`nav-item nav-link aiGrading-tab ${!proceedToOrder || !orderConfirmed ? 'disabled' : ''}`} id="nav-tab3-tab" data-toggle="tab"
               href={"#nav-tab3"}
               role="tab" aria-controls="nav-tab3" aria-selected="false">
              <i className="fas fa-check" /><b className="ml-2">{I18n.t('js.editCartPage.tabConfirm').toUpperCase()}</b>
            </a>
          </div>

          <div className="nav nav-tabs nav-fill justify-content-center show-on-mobile border-blu-aiGrading" id="nav-tab" role="tablist">
            <a className="nav-item nav-link aiGrading-tab active" id="nav-tab1-tab" data-toggle="tab"
               href={"#nav-tab1"}
               role="tab" aria-controls="nav-tab1" aria-selected="true">
              <i className="fas fa-shopping-cart" />
            </a>
            <a className={`nav-item nav-link aiGrading-tab ${!proceedToOrder ? 'disabled' : ''}`} id="nav-tab2-tab" data-toggle="tab"
               href={"#nav-tab2"}
               role="tab" aria-controls="nav-tab2" aria-selected="false">
              <i className="fas fa-shipping-fast" />
            </a>
            <a className={`nav-item nav-link aiGrading-tab ${!proceedToOrder || !orderConfirmed ? 'disabled' : ''}`} id="nav-tab3-tab" data-toggle="tab"
               href={"#nav-tab3"}
               role="tab" aria-controls="nav-tab3" aria-selected="false">
              <i className="fas fa-check" />
            </a>
          </div>

        </nav>

        <div className="tab-content" id="nav-tabContent">
          <div className="tab-pane p-1 active" id="nav-tab1" role="tabpanel"
               aria-labelledby="nav-tab1-tab">

            {
              numberOfProducts > 0 &&
              <div className={`d-flex mb-20px-imp ${ $(window).innerWidth() < IPAD_WIDTH ?'m-auto justify-content-center'  :'mr-5perc justify-content-end'}`}>
                <button
                  type="button"
                  className="btn-standard bg-aig-gradient text-light br-20px shadow pr-2 pl-2 btn-standard-resized h-75 mt-20px minW-350px"
                  onClick={(e) => {proceedToOrderHandler(e)} }
                >
                  {I18n.t('js.editCartPage.proceedToOrder')}
                </button>
              </div>
            }

            <CartContent
              loading={loading}
              cartItems={cartItems}
              getCartItems={getCartItems}
              hasLoadedAllCartItems={hasLoadedAllCartItems}
              handleShowLargeImage={handleShowLargeImage}
              showPopupToDeleteItem={showPopupToDeleteItem}
              isBusinessAccount={isBusinessAccount}
            />
          </div>

          <div className="tab-pane p-1" id="nav-tab2" role="tabpanel"
               aria-labelledby="nav-tab3-tab">
            <div className={`${ window.innerWidth<DESKTOP_WIDTH ? 'w-90': 'w-60'} m-auto mt-10px`}>
              <PaymentAndShippingForm
                numberOfProducts={numberOfProducts}
                shipment_addresses={shipment_addresses}
                confirmHandler={confirmOrderHandler}
                validShipmentAddress={validShipmentAddress}
                setValidShipmentAddress={setValidShipmentAddress}
                countries={countries}
                descriptionTitle={I18n.t('js.editCartPage.specifyYourAddress')}
                canUpdate={true}
              />
            </div>
          </div>

          <div className="tab-pane p-1" id="nav-tab3" role="tabpanel"
               aria-labelledby="nav-tab3-tab">
            <div className="mt-5 text-center container">
              <h1 className="mt-5 text-aiBlue text-weight-700">
                {I18n.t('js.editCartPage.step3Congratulation')}</h1>
              <h3>
                {I18n.t('js.editCartPage.step3ViewOrderConfirmed')}
              </h3>
              <h3 className="mb-30px">
                {I18n.t('js.editSubmissionListPage.step3MailWithDetails')}
              </h3>
            </div>
            <div className="d-flex justify-content-center mt-5 text-center">
              <a
                type="button"
                style={{ width: "200px" }}
                className="btn-standard bg-dark text-light pr-2 pl-2 btn-standard-resized pt-4px-imp h-35px"
                href={"/orders?orders_type=sent"}
              >
                {I18n.t('js.editCartPage.step3ViewSubmissionList')}
              </a>
            </div>
          </div>
        </div>
      </div>

      <ErrorModal
        showErrorModal={showErrorModal}
        setShowErrorModal={setShowErrorModal}
        additionalText={I18n.t('js.editCartPage.errorModalText')}
      />

      <SuccessFlashMessage
        showSuccessFlashMessage={showSuccessFlashMessage}
        setShowSuccessFlashMessage={setShowSuccessFlashMessage}
      />

      <FullScreenLoadingOverlay
        showFullScreenLoadingOverlay={isOrderInProgress}
        textFullScreenLoadingOverlay={I18n.t('js.editCartPage.orderInProgress')}
      />

      <ShowLargeImageModal
        blueprintImage={blueprintImage2ShowLargeImage ? blueprintImage2ShowLargeImage : ''}
        showZoomImg={showZoomImg}
        setShowZoomImg={setShowZoomImg}
      />

      {/*Alert for delete all items*/}
      <AlertPopup
        showAlertPopup={showDeleteAllItemsPopup}
        onSuccess={onDeleteAllHandler}
        onDiscard={setShowDeleteAllItemsPopup}
        popupTitle={`${I18n.t('js.myCollectionEditPage.userPopupDeleteCardsTitle')}`}
        popupContent={`${I18n.t('js.editCartPage.userPopupDeleteCardsContent')}`}
        cancelButtonText={`${I18n.t('js.common.button.cancel').toUpperCase()}`}
        confirmButtonText={`${I18n.t('js.common.button.delete').toUpperCase()}`}
      />

      {/*Alert for delete sigle items*/}
      <AlertPopup
        showAlertPopup={showDeleteItemPopup}
        onSuccess={() => onDeleteHandler(itemToDelete,itemToDeletePrice,itemToDeleteAvailableForSale)}
        onDiscard={setShowDeleteItemPopup}
        popupTitle={`${I18n.t('js.editSubmissionListPage.userPopupDeleteSingleItemTitle')}`}
        popupContent={`${I18n.t('js.editCartPage.userPopupDeleteSingleItemContent')}`}
        cancelButtonText={`${I18n.t('js.common.button.cancel').toUpperCase()}`}
        confirmButtonText={`${I18n.t('js.common.button.delete').toUpperCase()}`}
      />

    </React.Fragment>
  );
};

export default Cart;